import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Toast from '../../components/Toast';
import StockManagement from './StockManagement';
import BranchStockHandover from './BranchStockHandover';
import './SuperadminPanel.css';

function SuperadminPanel() {
  const [toast, setToast] = React.useState(null);
  const [activeTab, setActiveTab] = React.useState('dashboard');
  const { username, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
      setToast({ message: 'Logged out successfully', type: 'success' });
      setTimeout(() => {
        navigate('/admin-login');
      }, 500);
    }
  };

  return (
    <div className="superadmin-panel-fullpage">
      {toast && (
        <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />
      )}

      {/* ── Header ── */}
      <div className="superadmin-header-fullpage">
        <div className="superadmin-header-left">
          <h1>Superadmin Panel</h1>
          <p className="superadmin-subtitle">Welcome to the Superadmin Dashboard</p>
        </div>
        <div className="superadmin-header-info">
          <span className="superadmin-username">👤 {username}</span>
        </div>
        <div className="superadmin-header-buttons">
          <button className="btn-logout-fullpage" onClick={handleLogout} title="Logout">
            🚪 Logout
          </button>
        </div>
      </div>

      {/* ── Tab Navigation ── */}
      <div className="superadmin-tabs">
        {/* <button
          className={`tab-button ${activeTab === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveTab('dashboard')}
        >
          📊 Dashboard
        </button> */}
        <button
          className={`tab-button ${activeTab === 'stock' ? 'active' : ''}`}
          onClick={() => setActiveTab('stock')}
        >
          Stock Management
        </button>
        <button
          className={`tab-button ${activeTab === 'handover' ? 'active' : ''}`}
          onClick={() => setActiveTab('handover')}
        >
        Branch Distribution
        </button>
      </div>

      {/* ── Dashboard Tab ── */}
      {activeTab === 'dashboard' && (
        <div className="superadmin-empty-fullpage">
          <span className="empty-icon">✨</span>
          <h2>Welcome to Superadmin Panel</h2>
          <p>Select a feature from the tabs above to get started</p>
        </div>
      )}

      {/* ── Stock Management Tab ── */}
      {activeTab === 'stock' && (
        <div className="superadmin-content-section">
          <StockManagement />
        </div>
      )}

      {/* ── Branch Distribution Tab ── */}
      {activeTab === 'handover' && (
        <div className="superadmin-content-section">
          <BranchStockHandover />
        </div>
      )}
    </div>
  );
}

export default SuperadminPanel;
